var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showValue)?_c('div',{staticClass:"suggestion-argument"},[_c('div',{staticClass:"suggestion-id-wrap"},[_vm._v(" ID: "),_c('span',[_vm._v(_vm._s(_vm.value))])]),_c('ClampedText',[_vm._v(" "+_vm._s(_vm.suggestionText)+" ")])],1):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }